export interface IFormEditorData {
	title: string;
	rows: IFormEditorRow[];
	callback: (rows: IFormEditorRow[]) => void;
}
export interface IFormFieldEditorData {
	row: IFormEditorRow;
	callback: (row: IFormEditorRow) => void;
}
export interface IFormEditorSelectOption {
	value: string | number;
	label: string;
}
export interface IFormEditorRow {
	title?: string;
	key: string;
	value: any;
	newValue?: any;
	icon?: string;
	displaySize?: FormDisplaySize;
	placeholder?: string;
	type: FormEditorInputType;
	validators: FormValidatorType[];
	valids?: any[];
	editable: boolean;
	options?: IFormEditorSelectOption[];
}
export enum FormValidatorType {
	email = 'email',
	uniq_email = 'uniq_email',
	validUrlCheck = 'validUrlCheck',
	validUrlFormat = 'validUrlFormat',
	password = 'password',
	confirmPassword = 'confirmPassword',
	required = 'required'
}
export enum FormEditorInputType {
	text = 'text',
	email = 'email',
	number = 'number',
	password = 'password',
	url = 'url',
	select = 'select',
	date = 'date',
	tel = 'tel'
	// time = 'time',
	// month = 'month',
	// week = 'week',
}
export enum FormDisplaySize {
	small = 'small',
	medium = 'mediem',
	large = 'large'
}
